module.exports = require("timers");


//////////////////
// WEBPACK FOOTER
// external "timers"
// module id = 2094
// module chunks = 0 1 2